import React from "react";
import { Breadcrumb } from "../../../../components/Breadcrumb";

export const History = () => {
    document.title = "Tarixçə";

    const menu = [
        { name: "Ana səhifə", value: "/" },
        { name: "Ayarlar", value: "/settings" },
        { name: "Ödəniş", value: "/settings/payment" },
        { name: "Tarixçə", value: "/settings/payment/history", current: true },
    ];

    return (
        <div>
            <Breadcrumb menu={menu} />
            <div className="container">
                <article>
                    <h2 className="my-4">Tarixçə</h2>
                    <p>
                        Balans səhifəsində <b>Ödəniş tarixçəsi</b> sözünün üzərinə klik olunsa, istifadəçinin ödəniş etdiyi tarixlər və məbləğlər göstəriləcək.
                        <br />
                        Nümunədə istifadəçinin sistemdən istifadə etmək üçün etdiyi ödənişlər və məbləğlərin siyahısı göstərilir.
                    </p>
                    <img src="/images/settings/payment/history.gif" alt="Tarixçə" />
                </article>
            </div>
        </div>
    );
};
